<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>A special thank you to my husband, Philip, who helped tremendously in putting in hours of his time proofreading a story that I know was extremely painful for him to read over and over again.</p><br/>
<p style="text-indent: 0em;">Also, a special thanks to my close family, friends, and catholic priests who kept praying for me and encouraging me to finish my book. If I had not had that continued encouragement, I probably would have given up on writing a long time ago.</p><br/>
<p style="text-indent: 0em;">I truly appreciate the Editor Production Department, especially, Jessica Bosak at Austin Macauley Publications for making my book to the public possible.</p><br/>
<p style="text-indent: 0em;">Most of all I thank God for giving me the courage and strength to be able to relive my experiences and turn my thought into words. I know on my own, without God’s help that never would have been possible.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?b747dc90